import { render, staticRenderFns } from "./BreakHistories.vue?vue&type=template&id=201f9828&"
import script from "./BreakHistories.vue?vue&type=script&lang=js&"
export * from "./BreakHistories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports